module.exports = __webpack_public_path__ + "resources/img/bg_tcc_inquiry_m.0e84a931b17fb1cab82e74f19739855e.png";